<template>
  <div class="returnCarBegin-add">
    <QS-scroller-box>
      <div class="returnCarInfo-wrapper">
        <p class="title">发起退车</p>
        <form-text-box
          ref="returnCarInfo"
          :column="2"
          :dataList="returnCarInfo.list"
          :model="returnCarInfo.model"
          :rules="returnCarInfo.rules"
        />
      </div>

      <QS-h4-title title="车辆信息" />
      <form-text-box
        ref="carInfo"
        :column="3"
        :dataList="carInfo.list"
        :model="carInfo.model"
      />

      <QS-h4-title title="订单信息" />
      <form-text-box
        ref="orderInfo"
        :column="3"
        :dataList="orderInfo.list"
        :model="orderInfo.model"
      />

      <QS-h4-title title="客户信息" />
      <form-text-box
        ref="customerInfo"
        :column="3"
        :dataList="customerInfo.list"
        :model="customerInfo.model"
      />

      <template slot="bottomAction">
        <div class="btn-group">
          <el-button @click="handleCancel">取消</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="formSubmitLoading">发起退车</el-button>
        </div>
      </template>
    </QS-scroller-box>

    <!-- 解约前代扣校验 -->
    <TerminateWithhold ref="terminateRef" :orderId="orderDetail.id" :callback="delaySubmit" />

    <dialogWrap :title="'提示'" v-model='dialogConfirmData.visible' :width="'30%'">
      <span>{{dialogConfirmData.content}}</span>
      <template slot="footer">
        <el-button @click="dialogConfirmData.visible = false">取消</el-button>
        <el-button @click="dialogConfirm" type="primary" :loading="dialogSubmitLoading">确认</el-button>
      </template>
    </dialogWrap>
  </div>
</template>

<script>
import { debounce } from '@/utils'
import { getOrderLeaseList, getOrderDetail, submitPersonalReturnCar, submitEnterpriseReturnCar, checkOrderNeedRefund } from '@/api/domain/returnLease'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import { ORDER_STATES, ORDER_TYPES, CUSTOMER_TYPES } from '@/pages/cars/returnCar/config'
import { mixin, ORDER_QUERY_BY_CARID, ORDER_QUERY_BY_CUSTOMERID } from './config'
import TerminateWithhold from '@/pages/orders/components/TerminateWithhold.vue'
import { getSimpleCarList } from '@/api/carManage/index.js'

export default {
  components: { TerminateWithhold },
  mixins: [mixin],
  inject: ['orderType', 'orderData'],
  data() {
    return {
      dialogConfirmData: { visible: false, content: '' },
      orderDetail: {},
      carList: [],
      customerList: [],
      queries: JSON.parse(decodeURIComponent(this.$route.query.query || '{}')),
      extendParams: {}, // 提交参数
      leaseOrderList: [], // 订单列表
      submitLoading: false, // 发起退车提交按钮loading
    }
  },
  computed: {
    formSubmitLoading() {
      return !this.dialogConfirmData.visible && this.submitLoading
    },
    dialogSubmitLoading() {
      return this.dialogConfirmData.visible && this.submitLoading
    },
  },
  watch: {
    // 监听车牌号变化，并搜索订单ID
    'returnCarInfo.model.carId': {
      handler: debounce(function (val) {
        if (val) {
          this.getRentOrderId()
        } else {
          this.reset()
        }
      }, 300),
      immediate: true,
    },
    // 监听客户名称变化，并搜索订单ID
    'returnCarInfo.model.customerId': {
      handler: debounce(function (val) {
        if (val) {
          this.getRentOrderId()
        } else {
          this.reset()
        }
      }, 300),
      immediate: true,
    },
    // 监听订单ID变化，获取订单信息
    'returnCarInfo.model.orderId': {
      handler: debounce(async function (val) {
        // 找到退车类型的表单配置选项
        const returnTypeItem = this.returnCarInfo.list.find((item) => item.itemConfig.prop === 'returnType')
        if (val) {
          const data = await this.getOrderDetail(val)
          if (data) {
            this.backfillOrderInfo(data)
          }
        } else {
          this.resetOtherFields()
        }
        // 有订单ID 再设置退车类型是否可选
        returnTypeItem.elConfig.disabled = !val

        const orderItem = this.leaseOrderList.find((item) => item.id === val)

        const returnTypeList = (orderItem?.supportReturnTypeList || []).map((item) => {
          return {
            name: item.returnTypeName,
            value: item.returnType,
          }
        })

        this.$refs.returnCarInfo.setItemData({ elConfigKey: 'list', key: 'returnType', data: returnTypeList })
      }, 300),
      immediate: true,
    },
  },
  methods: {
    async init() {
      const { orderId } = this.queries
      if (orderId) {
        const data = await this.getOrderDetail(orderId)
        if (data) {
          await this.gerCarList(data.plateNo || '')
          this.backfillCarId(data.carId || '')
          this.backfillOrderId(data.id || '')
        }
      } else {
        this.getCarListFromServer()
      }
    },
    // 重新请求下拉列表数据
    getListData() {
      if (this.orderQueryType === 'carId') {
        this.resetCarIdSelectOptions()
      } else {
        this.resetCustomerIdSelectOptions()
      }
    },
    reset() {
      this.resetOrderId()
      this.resetOrderIdSelectOptions()
      this.resetSearchFields()
      this.resetOtherFields()
    },
    resetOrderId() {
      this.$set(this.returnCarInfo.model, 'orderId', '')
    },
    resetOrderIdSelectOptions() {
      this.$refs.returnCarInfo?.setItemData({ elConfigKey: 'list', key: 'orderId', data: [] })
    },
    // 重新请求数据源，并设置下拉列表
    resetCarIdSelectOptions() {
      this.getCarListFromServer()
    },
    // 重新请求数据源，并设置下拉列表
    resetCustomerIdSelectOptions() {
      this.getCustomerListFromServer()
    },
    resetSearchFields() {
      this.$refs.returnCarInfo?.getRefs()?.resetFields()
    },
    resetOtherFields() {
      this.$refs.carInfo?.getRefs()?.resetFields()
      this.$refs.orderInfo?.getRefs()?.resetFields()
      this.$refs.customerInfo?.getRefs()?.resetFields()
    },
    // 查询方式切换
    // eslint-disable-next-line vue/no-unused-properties
    handelOrderQueryTypeToggle() {
      this.reset()
      if (this.orderQueryType === ORDER_QUERY_BY_CARID) {
        this.orderQueryType = ORDER_QUERY_BY_CUSTOMERID
        this.$refs.returnCarInfo.setItemData({ elConfigKey: 'isShow', key: 'carId', data: false })
        this.$refs.returnCarInfo.setItemData({ elConfigKey: 'isShow', key: 'customerId', data: true })
        delete this.returnCarInfo.model.carId
      } else {
        this.orderQueryType = ORDER_QUERY_BY_CARID
        this.$refs.returnCarInfo.setItemData({ elConfigKey: 'isShow', key: 'customerId', data: false })
        this.$refs.returnCarInfo.setItemData({ elConfigKey: 'isShow', key: 'carId', data: true })
        delete this.returnCarInfo.model.customerId
      }
      this.getListData()
    },
    // 获取车辆列表
    async gerCarList(query) {
      query = query.trim()
      if (query.length >= 1) {
        this.getCarListFromServer(query)
      }
    },
    async getCarListFromServer(query) {
      let carList
      this.$refs.returnCarInfo.setItemData({ elConfigKey: 'loading', key: 'carId', data: true })
      try {
        const { code, data } = await getSimpleCarList({
          plateNo: query,
          state: 1,
        })
        if (code === 1) {
          carList = data || []
        }
        this.$refs.returnCarInfo.setItemData({ elConfigKey: 'loading', key: 'carId', data: false })
      } catch (err) {
        carList = []
        this.$refs.returnCarInfo.setItemData({ elConfigKey: 'loading', key: 'carId', data: false })
      }
      if (!carList.length) {
        this.$message.warning('车牌号不存在')
        this.reset()
      }
      this.$refs.returnCarInfo.setItemData({ elConfigKey: 'list', key: 'carId', data: carList })
      this.carList = carList
    },
    // 获取客户列表
    // eslint-disable-next-line vue/no-unused-properties
    async getCustomerList(query) {
      query = query.trim()
      if (query.length >= 1) {
        this.getCustomerListFromServer(query)
      }
    },
    async getCustomerListFromServer(query) {
      let customerList
      this.$refs.returnCarInfo.setItemData({ elConfigKey: 'loading', key: 'customerId', data: true })
      try {
        const { code, data = [] } = await searchByCustomerNameSensitive({
          customerName: query,
          customerType: this.orderType === ORDER_TYPES.personal.value ? CUSTOMER_TYPES.personal.value : CUSTOMER_TYPES.enterprise.value,
        })
        if (code === 1 && data) {
          customerList = data
        }
        this.$refs.returnCarInfo.setItemData({ elConfigKey: 'loading', key: 'customerId', data: false })
      } catch (err) {
        customerList = []
        this.$refs.returnCarInfo.setItemData({ elConfigKey: 'loading', key: 'customerId', data: false })
      }
      if (!customerList.length) {
        this.$message.warning('客户名称不存在')
        this.reset()
      }
      this.$refs.returnCarInfo.setItemData({ elConfigKey: 'list', key: 'customerId', data: customerList })
      this.customerList = customerList
    },
    // 根据车牌号或客户姓名查询订单
    async getRentOrderId() {
      const res = await getOrderLeaseList({
        carId: this.returnCarInfo.model.carId || undefined,
        customerId: this.returnCarInfo.model.customerId || undefined,
        orderBizType: this.orderType, // 10: 个人订单 20: 企业子订单
      })

      if (!res) return

      const { code, data } = res
      if (code === 1) {
        this.$nextTick(() => {
          this.$refs.returnCarInfo?.$refs.form?.clearValidate('orderId')
        })
        if (data && data.length) {
          this.leaseOrderList = data
          const orderIdList = data.map((item) => ({ label: `${item.startDate}~${item.contractEndDate}`, value: item.id }))
          this.$refs.returnCarInfo.setItemData({ elConfigKey: 'list', key: 'orderId', data: orderIdList })

          // 如果只有一个订单则自动填充
          if (data.length === 1) {
            this.returnCarInfo.model.orderId = data[0].id
          }
        } else {
          if (this.returnCarInfo.model.carId) {
            this.$message.warning('车牌号无履约中状态订单，无法发起退车')
          } else {
            this.$message.warning('客户无履约中状态的订单，无法发起退车')
          }

          this.$refs.returnCarInfo.setItemData({ elConfigKey: 'list', key: 'orderId', data: [] })
        }
      }
    },
    // 获取订单详情
    async getOrderDetail(orderId) {
      const res = await getOrderDetail({ orderId })

      if (!res) return

      const { code, data } = res

      if (code === 1) {
        this.orderDetail = data
        return data
      }
    },
    // 延迟退车提交
    delaySubmit(check, extendParams = {}) {
      this.extendParams = extendParams
      this.submitReturnCar(check)
    },
    // 提交还车
    async submitReturnCar(check) {
      const { relatedType, renewalOfContract } = this.orderDetail
      let isCheck
      if (check === undefined) {
        // relatedType 4续约单  renewalOfContract 1原单
        isCheck = relatedType === 4 || renewalOfContract === 1 ? 1 : 0
      } else {
        isCheck = check
      }
      this.submitLoading = true
      const apiFn = this.orderType === ORDER_TYPES.personal.value ? submitPersonalReturnCar : submitEnterpriseReturnCar
      const [err, res] = await this.$to(apiFn({
        orderId: Number(this.returnCarInfo.model.orderId),
        returnType: Number(this.returnCarInfo.model.returnType),
        returnReason: this.returnCarInfo.model.returnReason,
        isCheck, // 0 1 收否走弹窗检查
        ...this.extendParams,
      }))
      this.submitLoading = false
      if (err || !res) return

      const { code, data } = res
      if (code === 1) {
        this.$message.success('发起成功')
        setTimeout(() => {
          this.$emit('returnCarBeginCompleted', {
            id: data,
            orderId: Number(this.returnCarInfo.model.orderId),
          })
        }, 1200)
      } else if (code === 29025) {
        // 续约单操作退车解约 原单未到截止日期
        this.dialogConfirmData.visible = true
        this.dialogConfirmData.content = '该订单还未正式执行，「退车解约」将直接取消订单，不需要退车和结算，确认取消此续约订单请点击「确定」'
      } else if (code === 29024) {
        // 原单操作退车解约 原单已续约，且原单未到截止期
        this.dialogConfirmData.visible = true
        this.dialogConfirmData.content = '该订单已续约，若发起退车后续约订单将作废，是否确认继续？'
      } else if (code === 29026) {
        // 原单操作退车解约 原单已到截止期 且存在待确认的续约单
        this.dialogConfirmData.visible = true
        this.dialogConfirmData.content = '该订单存在待确认的续约订单，如操作「退车解约」会自动作废续约订单，继续退车请点击「确定」'
      }
    },
    // 回填车辆ID
    backfillCarId(carId) {
      if (carId) {
        this.returnCarInfo.model.carId = carId
      }
    },
    // 回填订单ID
    backfillOrderId(orderId) {
      if (orderId) {
        this.returnCarInfo.model.orderId = orderId
      }
    },
    // 回填订单信息
    backfillOrderInfo(data) {
      const carInfoModel = {
        // 车牌号
        plateNo: data.plateNo || '',
        // 车辆ID
        carId: data.carId || '',
        // 车型
        modelName: data.modelName || '',
        // 车辆状态
        carState: data.carState || '',
        // 库存状态
        inventoryState: data.inventoryState === 1 ? '在库' : '出库',
        // 车辆品牌
        brandName: data.brandName || '',
        // 车系名称
        seriesName: data.seriesName || '',
      }
      const orderInfoModel = {
        // 订单ID
        id: data.id || '',
        // 企业主订单ID
        entRentOrderId: data.entRentOrderId || '',
        // 订单类型
        type: this.orderType === ORDER_TYPES.personal.value ? '个人订单' : '企业子订单',
        // 订单状态
        state: (Object.values(ORDER_STATES).find((item) => item.value === data.state) || {}).name || '',
        // 收款起止日
        receivablePeriod: data.receivablePeriod || '',
        // 赠送天数
        presentDays: `${data.presentDays || 0}天`,
        // 免租周期
        presentDate: data.presentStartDate && data.presentEntDate ? `${data.presentStartDate} ~ ${data.presentEntDate}` : '',
        // 租金总金额
        totalAmount: (data.totalAmount || '') + (data.totalAmount && !String(data.totalAmount).endsWith('元') ? '元' : ''),
        // 押金金额
        totalDeposit: (data.totalDeposit || '') + (data.totalDeposit ? '元' : ''),
      }
      const customerInfoModel = {
        // 客户ID
        customerId: data.customerId || '',
        // 客户类型
        customerType: this.orderType === ORDER_TYPES.personal.value ? '个人' : '企业',
        // 客户名称
        customerName: data.customerName || '',
      }

      this.carInfo.model = carInfoModel
      this.orderInfo.model = orderInfoModel
      this.customerInfo.model = customerInfoModel

      this.returnCarInfo.model.deptName = data.deptName || ''
    },
    handleCancel() {
      this.$refs.returnCarInfo.getRefs().resetFields()
      this.$refreshBack(false)
    },
    handleSubmit: debounce(function () {
      this.submitLoading = true
      this.$refs.returnCarInfo.getRefs().validate(async (valid) => {
        if (valid) {
          // 个人订单还车走校验逻辑，企业订单不校验
          if (this.orderType === ORDER_TYPES.personal.value) {
            this.checkOrderNeedToRefund()
          } else {
            this.submitReturnCar()
          }
        } else {
          this.submitLoading = false
        }
      })
    }, 200),
    dialogConfirm() {
      this.dialogConfirmData.visible = false
      this.submitReturnCar(0)
    },
    // 判断是否有金额退款，司机已支付且签约完成但未发车
    async checkOrderNeedToRefund() {
      if (this.orderData.state === 1500) {
        const { data } = await checkOrderNeedRefund({
          orderId: this.orderData.id,
        })
        if (data) {
          this.$confirm('发起退车后，将原路退还司机已线上支付的全部金额。是否继续？', '发起退车', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            await this.$refs.terminateRef.preCheck()
            this.submitLoading = false
          }).catch(() => {
            this.submitLoading = false
          })
        } else {
          await this.$refs.terminateRef.preCheck()
          this.submitLoading = false
        }
      } else {
        await this.$refs.terminateRef.preCheck()
        this.submitLoading = false
      }
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-input--prefix .el-input__inner {
    padding-left: 12px !important;
  }
  .returnCarInfo-wrapper {
    padding: 0 0 12px 0;
  }
  .title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 12px;
    font-weight: 600;
    font-size: 16px;
    color: #323233;
    margin-bottom: 14px;
  }
  .btn-group {
    display: flex;
    justify-content: center;
  }
  .mt-36 {
    margin-top: 36px;
  }
</style>
